export default __webpack_public_path__ + "images/light-blue-circle.bb68e7a6cd6a787008bddca85fd62fd9.svg";